






















































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Visualization } from '../../../core/models';
@Component
export default class VisualizationsPanel extends Vue {
    @Prop() visualizations: Visualization[];
    @Prop() visualizationSelected: Visualization;
    @Prop() loading: boolean;

    @Emit()
    applyVisualization(visualization: Visualization) {}

    @Emit()
    unApplyVisualization(visualization: Visualization) {}

    shouldShowUnApply(visualization: Visualization): boolean {
        return this.visualizationSelected && this.visualizationSelected.name === visualization.name;
    }

    isActiveVisualization(id: string): boolean {
        if (this.visualizationSelected) {
            return id === this.visualizationSelected.id;
        } else {
            return false;
        }
    }
}
